import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useRdpModal } from '@hungryroot/rdp';
import RecipesRoute from './RecipesRoute';
import FiltersSidebar from './FiltersSidebar';
import TopFilterBar from './TopFilterBar';
import Search from '../../customize/components/Search';
import Modal from '../../generic/Modal';
import RDPModal from '../../generic/RdpModal';
import NavbarReplacer from '../../generic/NavbarReplacer';
import CtaHeader from '../../generic/CtaHeader';
import GroceriesRoute from './GroceriesRoute';
import QueryParamsFilters from '../../customize/components/QueryParamsFilters';
import {
  getFilteredRecipes,
  getDishtypes,
  selectRecipeDishtype,
  applyRecipeFilters,
  toggleRecipeFilter,
  clearRecipeFilters,
  updateSearchText,
  getCategories,
  selectSkuCategory,
  getFilteredSkus,
  clearSkuFilters,
  applySkuFilters,
  getTagOptions,
} from '../../customize/actions_creators';
import PDPModalContainer from '../../generic/product/PDPModalContainer';
import { customerId, isFoodsPage } from '../../customize/const';
import styles from './AppWrapper.module.css';

const AppWrapper = (props) => {
  const { rdpPairing, toggleRdpModal } = useRdpModal();

  useEffect(() => {
    const isMobile = $.browser.mobile;
    const itemDisplayContainer = document.getElementsByClassName(
      'items-display-container'
    )[0];
    const scrollConstant =
      $('.header').height() +
      $('.menu-wrapper').height() +
      $('.splash-area').height();

    props.getCategories();
    props.getTagOptions();

    if (!isMobile) {
      window.addEventListener('scroll', (_) => {
        if (window.scrollY > scrollConstant) {
          $(itemDisplayContainer).css({
            top: $('.menu-wrapper').height(),
            position: 'fixed',
          });
          return;
        }
        $(itemDisplayContainer).css({ top: 'initial', position: 'relative' });
        return;
      });
    }
  }, []);

  let {
    dishtypes,
    selectedDishtype,
    selectRecipeDishtype,
    getFilteredRecipes,
    recipesTotalCount,
    dishTypeCount,
    categories,
    selectedSkuCategory,
    skusTotalCount,
    categoryCount,
    selectSkuCategory,
    getFilteredSkus,
    filtersVisibility,
  } = props;

  const selectAndRefreshRecipes = (dishtype) => {
    selectRecipeDishtype(dishtype);
    getFilteredRecipes();
  };

  const selectAndRefreshSkus = (category) => {
    selectSkuCategory(category);
    getFilteredSkus();
  };

  return (
    <>
      <RDPModal
        customerId={customerId}
        segmentPath="cookbook"
        pairing={rdpPairing}
        visible={!!rdpPairing}
        onClose={() => toggleRdpModal(null)}
      />
      <PDPModalContainer isCustomizationPage={false} />
      <CtaHeader
        isFoodsPage={isFoodsPage}
        preCheckout={!!parseInt(window.preCheckout)}
        surveyStartedFoods={window.surveyStarted}
      />
      <div id="app-wrapper-id" className="app-wrapper hr-base-width">
        <NavbarReplacer>
          <div className="top-bar-container">
            <TopFilterBar
              filterOptions={isFoodsPage ? categories : dishtypes}
              selectedFilter={
                isFoodsPage ? selectedSkuCategory : selectedDishtype
              }
              selectFilter={
                isFoodsPage ? selectAndRefreshSkus : selectAndRefreshRecipes
              }
              isRecipe={isFoodsPage ? false : true}
              totalCount={isFoodsPage ? skusTotalCount : recipesTotalCount}
              filterCounts={isFoodsPage ? categoryCount : dishTypeCount}
            />
            <div className={styles['hr-desktop']}>
              <Search />
            </div>
            <div className={`${styles['hr-mobile']} dont-show-close`}>
              <Search />
            </div>
          </div>
        </NavbarReplacer>
        <div className="page-container hr-base-width">
          <div className="recipe-tool-filters">
            <FiltersSidebar
              isFoods={isFoodsPage ? true : false}
              filtersVisibility={filtersVisibility}
            />
          </div>
          {isFoodsPage ? <GroceriesRoute /> : <RecipesRoute />}
        </div>
      </div>
      <QueryParamsFilters recipesRoute={!isFoodsPage} />
    </>
  );
};

let mapStateToProps = (state) => {
  return {
    dishtypes: state.featured.dishtypes,
    recipes: state.filters.recipes,
    selectedDishtype: state.filters.selectedDishType,
    appliedRecipesFilters: state.filters.appliedRecipeFilters,
    canLoadMoreRecipes: state.filters.canLoadMoreRecipes,
    dishTypeCount: state.filters.dishTypeCount,
    recipesTotalCount: state.filters.recipesTotalCount,
    appliedSearchText: state.filters.appliedSearchText,
    skus: state.filters.skus,
    appliedSkuFilters: state.filters.appliedSkuFilters,
    selectedSkuCategory: state.filters.selectedSkuCategory,
    categories: state.featured.categories,
    canLoadMoreSkus: state.filters.canLoadMoreSkus,
    skusTotalCount: state.filters.skusTotalCount,
    categoryCount: state.filters.categoryCount,
    totalCount: state.filters.skusTotalCount,
    sorting: state.filters.sorting,
    error: state.filters.error,
    filtersVisibility: state.filters.filtersVisibility,
  };
};

let mapDispatchToProps = (dispatch) => {
  return {
    getFilteredRecipes: (loadMore) => dispatch(getFilteredRecipes(loadMore)),
    getDishtypes: () => dispatch(getDishtypes()),
    selectRecipeDishtype: (dishtype) =>
      dispatch(selectRecipeDishtype(dishtype)),
    toggleRecipeFilter: (filter, filterCategory) =>
      dispatch(toggleRecipeFilter(filter, filterCategory)),
    applyRecipeFilters: () => dispatch(applyRecipeFilters()),
    clearRecipeFilters: () => dispatch(clearRecipeFilters()),
    updateSearchText: (text) => dispatch(updateSearchText(text)),
    getFilteredSkus: (loadMore) => dispatch(getFilteredSkus(loadMore)),
    toggleSkuFilter: (filter, filterCategory) =>
      dispatch(toggleSkuFilter(filter, filterCategory)),
    applySkuFilters: () => dispatch(applySkuFilters()),
    clearSkuFilters: () => dispatch(clearSkuFilters()),
    selectSkuCategory: (category) => dispatch(selectSkuCategory(category)),
    getCategories: () => dispatch(getCategories()),
    getTagOptions: () => dispatch(getTagOptions()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppWrapper);
